import { FunctionComponent } from 'preact';
import Currency from '../common/Currency';
import { ProductVariant } from '../types';
import BuyingOptionsStock from './BuyingOptionsStock';

const BuyingOptionsTableVariantCell: FunctionComponent<BuyingOptionsTableVariantCellProps> = ({
    productVariant,
    isSpecialKnitwear,
    quantityInBasket,
    multiple,
    isProcessing,
    hidePrices,
    onChangeQuantity
}) => {
    const onValueChange = e => {
        onChangeQuantity(productVariant, parseInt(e.target.value, 10));
        // Add class to change input border colour
        e.target.value > 0 ? e.target.classList.add('valid') : e.target.classList.remove('valid');
    };

    return (
        <td class="buying-options__table-variant-cell align-top">
            <span class="d-flex align-center">
                <input
                    type="number"
                    id={productVariant.sku}
                    class={`buying-options__quantity-input form-control line-height-xs text-dark-grey px-3 border--gray ${
                        quantityInBasket ? 'valid' : null
                    }`}
                    value={quantityInBasket ?? 0}
                    placeholder="0"
                    step={multiple}
                    min="0"
                    name={`quantity-${productVariant.colour}-${productVariant.size}`}
                    autocomplete="off"
                    aria-label="Quantity"
                    disabled={isProcessing}
                    onChange={onValueChange}
                />
            </span>
            <span class={`buying-options__price mt-1 ${hidePrices ? 'd-none' : 'd-flex'}`}>
                <span class="font-weight-bold mr-2">
                    <Currency amount={String(productVariant.unit_price)} />
                </span>
                <span>each</span>
            </span>
            <BuyingOptionsStock
                stockLevel={productVariant.stock_level ?? 0}
                stockDueDate={productVariant?.stock_due_date}
                isSpecialKnitwear={isSpecialKnitwear}
            />
        </td>
    );
};

interface BuyingOptionsTableVariantCellProps {
    productVariant: ProductVariant;
    isSpecialKnitwear: boolean;
    quantityInBasket: number | undefined;
    multiple: number;
    isProcessing: boolean;
    hidePrices: boolean;
    onChangeQuantity: (productVariant: ProductVariant, quantity: number) => void;
}

export default BuyingOptionsTableVariantCell;
